/** Secondes restantes avant l'échéance, corrigées du décalage d'horloge serveur. */
export function secondsLeft(deadlineAt: number | null, clockOffset: number): number | null {
  if (deadlineAt === null) return null;
  return Math.max(0, Math.round((deadlineAt - (Date.now() + clockOffset)) / 1000));
}

export function formatDuration(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const rest = seconds % 60;
  return `${minutes}:${String(rest).padStart(2, '0')}`;
}
